import { useNavigate } from "react-router-dom";
import { Button } from "../../Button";
import { Modal } from "../../Modal";

interface LoginPromptModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function LoginPromptModal({ isOpen, onClose }: LoginPromptModalProps) {
  const navigate = useNavigate();

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Login Required">
      <div className="space-y-6" data-testid="modal-login-prompt">
        <p className="text-center">
          You need to log in to create a room. Please log in or create an
          account to continue.
        </p>
        <div className="flex flex-col gap-3">
          <Button
            variant="primary"
            onClick={() => navigate("/login")}
            className="w-full"
            data-testid="modal-login-prompt-login"
          >
            Log In
          </Button>
          <Button
            variant="secondary"
            onClick={onClose}
            className="w-full"
            data-testid="modal-login-prompt-cancel"
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
}
